import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import StoreCategoryItem from '../../containers/store/StoreCategoryItem';
import {CATEGORY_QRY} from '../../common/constants';
import {trackCategoryChange} from '../../actions/common/gaActions';
import {updateStoreDataAvailability} from "../../actions/store/storeActions";
import styles from "../../css/store/storeCategories.less";

class StoreCategoriesList extends React.Component {
    onCategorySelected = (event) => {
        const selectedCategoryKey = event.target.value;
        const category = this.props.categories.find(function(category){
            return category.key === selectedCategoryKey;
        });
        this.props.changeCategory(selectedCategoryKey, category.title,
            this.props.staticData, this.props.itemsList, this.props.activeOrder);
    };

    render() {
        const categories = this.props.categories;
        if(this.props.clientViewPort.isXs){
            return (
                <div className="categories-select-wrapper">
                    <select className="categories-select" onChange={this.onCategorySelected}>
                        {categories.map((category)=>{
                            return <option className="category-title" key={category.key} value={category.key} >{category.title}</option>
                        })}
                    </select>
                </div>
            )
        }
        return (
            <div className="categories-list" id="categories">
                {categories.map((c)=>{
                    return (
                        <StoreCategoryItem category={c} key={c.key}/>
                    )
                })}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const status = (state.orderStatus || {});
    const staticData = (state.staticData || {});
    return {
        clientViewPort: (state.clientViewPort || {}),
        itemsList: state.itemsList,
        activeOrder: status.activeOrder,
        staticData: staticData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeCategory: (key, name, staticData, itemsList, activeOrder) => {
            dispatch(trackCategoryChange(name));
            if (staticData.updateItemsAvailabilityOnCategoryChange) {
                dispatch(updateStoreDataAvailability(staticData, key, itemsList, activeOrder));
            }
            dispatch(push(location.pathname+CATEGORY_QRY+"="+key));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreCategoriesList);


// WEBPACK FOOTER //
// ./src/components/store/StoreCategoriesList.js